import React, { useEffect } from 'react';
import { useLocation } from 'wouter';
import { Button } from '../components/ui/button';

export default function NotFound() {
  const [, setLocation] = useLocation();

  // Initialize feather icons
  useEffect(() => {
    if (window.feather) {
      window.feather.replace();
    }
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <i data-feather="alert-triangle" className="w-16 h-16 text-yellow-500 mx-auto mb-4"></i>
          <h1 className="text-4xl font-bold text-gray-900 mb-2">404</h1>
          <h2 className="text-xl font-semibold text-gray-700 mb-4">Page Not Found</h2>
          <p className="text-gray-600 mb-8">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>

        <div className="space-y-4">
          <Button 
            className="w-full"
            onClick={() => setLocation('/')}
          >
            <i data-feather="home" className="w-4 h-4 mr-2"></i>
            Go to Dashboard
          </Button>
          
          <Button 
            variant="outline" 
            className="w-full"
            onClick={() => window.history.back()}
          >
            <i data-feather="arrow-left" className="w-4 h-4 mr-2"></i>
            Go Back
          </Button>
        </div>

        <div className="mt-8 text-sm text-gray-500">
          <p>If you believe this is an error, please contact support.</p>
        </div>
      </div>
    </div>
  );
}
